export default "__VITE_ASSET__DvcQaU2p__"